/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";

const HealthDemographics = () => {
  return (
    <div className="tabContent health-demographics">
      <div className="content">
        <div className="grpHdrPg">
          <h3>
            Patient Profile: <span>John Smith</span>
          </h3>
        </div>
        <div className="grpHdr">
          <h3>Health Demographics</h3>
        </div>
        <div>
          <b>Last Update:</b> 10/10/2000
        </div>
        <br />
        <br />
        <div className="row rowStretch health-demographics-row">
          <div className="col col-m-100 col60 col-container">
            <div className="row rowStretch">
              <div className="col col-s-100 col50">
                <label>
                  <span>Age</span> <input type="text" defaultValue />
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Diabetes Mellitus History</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Sex</span> <input type="text" defaultValue />
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Abnormal Renal Function</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Hypertension</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Abnormal Liver Function</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Congestive Heart Failure History</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Labile INR</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Stroke History</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Alcohol excess</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Vascular Disease History</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>Bleeding Predisposing</span>
                  <select>
                    <option disabled selected="selected">
                      Select
                    </option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>CHA2DS2-VASc</span>
                  <input type="text" defaultValue />
                </label>
              </div>
              <div className="col col-s-100 col50">
                <label>
                  <span>HAS-BLED</span> <input type="text" defaultValue />
                </label>
              </div>
              {/* col - end */}
            </div>
          </div>
          <div className="col col-m-100 col40 col-container">
            <div className="row rowStretch">
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>Pacing Dependency</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>History of AFIB</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>History of VT</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>History of VF</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>Anticoagulant</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>Antiplatelet</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              <div className="col col-s-100 col-m-50 col100">
                <label>
                  <span>Contraindication to Anticoagulation</span>
                  <select>
                    <option disabled>Select</option>
                    <option selected="selected">Not Available</option>
                  </select>
                </label>
              </div>
              {/* col - end */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthDemographics;
